export default {
  list: {},
  currentCompanyFetched: false,
};
